module.exports = __webpack_public_path__ + "img/welding-3.9f5ade97.jpg";